import Present from './lib/ui';
export default Present;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/index.js